<script>
	// Componentes Svelte
	import { Router, Link, link , Route }   from "svelte-routing";
	import { 
		linkAV, 
		linkRH, 
		textTelefone, 
		linkTelefone, 
		textWhatsappGeral, 
		linkWhatsappGeral,
	} from './store.js';

	// Componentes
	import Header 				from "./components/Header.svelte";
	import Footer 				from "./components/Footer.svelte";
	import Aviso 				from "./components/Aviso.svelte";

	// Rotas/Pages
	import Home 					from "./routes/Home.svelte";
	import Imoveis 					from "./routes/Imoveis.svelte";
	import Anuncie 					from "./routes/Anuncie.svelte";
	import Imovel 					from "./routes/Imovel.svelte";
	import DocumentacaoNecessaria 	from "./routes/DocumentacaoNecessaria.svelte";
	import GarantiasLocaticias 		from "./routes/GarantiasLocaticias.svelte";
	import FichasCadastrais 		from "./routes/FichasCadastrais.svelte";
	import SoliciteImovel 			from "./routes/SoliciteImovel.svelte";
	import AdministracaoCondominios from "./routes/AdministracaoCondominios.svelte";
	import SoliciteProposta 		from "./routes/SoliciteProposta.svelte";
	import Sobre 					from "./routes/Sobre.svelte";
	import OndeEstamos 				from "./routes/OndeEstamos.svelte";
	import TrabalheConosco 			from "./routes/TrabalheConosco.svelte";
	import Contato 					from "./routes/Contato.svelte";
	import Atualize 				from "./routes/Atualize.svelte";
	import Favoritos 				from "./routes/Favoritos.svelte";
	import FavoritosImobiliaria 	from "./routes/FavoritosImobiliaria.svelte";
	import FavoritosAmigos 			from "./routes/FavoritosAmigos.svelte";
	import Oops 					from "./routes/Oops.svelte";
	import Obrigado 				from "./routes/Obrigado.svelte";
	import Simuladores 				from "./routes/SimuladoresFinanceiros.svelte";
	import SeguroConteudo 			from "./routes/SeguroConteudo.svelte";
	import Promocoes 			from "./routes/Promocoes.svelte";
	
	// Code
	export let url 	= "";

	export let menu	= [
		{
			title: "Alugar",
			icon: '<i class="fas fa-key"></i>',
			subitems: [
				{
					title: 'Imóveis em Oferta',
					href: `/imoveis/locacao#nt=${atria.rent}&tipo_negociacao=${atria.rent}&cidade=Canela`,
					useLink: false,
					// forceReload: true
				},
				{
					title: 'Documentação Necessária',
					href: '/documentacao-necessaria'
				},
				{
					title: 'Garantias Locatícias',
					href: '/garantias-locaticias'
				},
				{
					title: 'Anuncie seu Imóvel',
					href: '/anuncie'
				},
				{
					title: 'Solicite um Imóvel',
					href: '/solicite-imovel'
				},
				{
					title: 'Atualização Cadastral',
					href: '/atualize'
				},
				{
					title: 'Favoritos',
					href: '/favoritos'
				},
			]			
		},
		{
			title: "Condomínios",
			icon: '<i class="fas fa-building"></i>',
			subitems: [
				{
					title: 'Administração de Condomínios',
					href: '/administracao-condominios'
				},
				{
					title: 'Solicite uma Proposta',
					href: '/solicite-proposta'
				},
				{
					title: 'Seguro Conteúdo',
					href: '/seguro-conteudo'
				},
				{
					title: 'Atualização Cadastral',
					href: '/atualize'
				}
			]
		},
		{
			title: 'Sobre',
			icon: '<i class="fas fa-map-marker"></i>',
			subitems: [
				{
					title: 'Sobre',
					href: '/sobre'
				},				
				{
					title: 'Onde Estamos',
					href: '/onde-estamos'
				},
				{
					title: 'Trabalhe Conosco',
					href: $linkRH,
					target: '_blank'
				}
			]
		},
		{
			title: 'Contato',
			icon: '<i class="fas fa-headset"></i>',
			href: '/contato'
		},
		{
			title: 'Área do Cliente',
			classe: 'btn btn-primary',
			icon: '<i class="fas fa-barcode-alt"></i>',
			href: $linkAV,
			target: '_blank'
		}
	];
	
	export let menuSecondary = [
		{
			title: 'Geral <b class="ml-1">' + $textTelefone + '</b>',
			icon: '<i class="fas fa-phone"></i>',
			href: $linkTelefone,
			target: '_blank'
		},
		{
			title: 'Whatsapp <b class="ml-1">' + $textWhatsappGeral + '</b>',
			icon: '<i class="fab fa-whatsapp"></i>',
			href: $linkWhatsappGeral,
			target: '_blank'
		},
	];
</script>

<Router url="{url}">
	<Header classe="" style="single" menu={menu} menuSecondary={menuSecondary} logoHeight="105" />
	<main class="fadeIn">
		<div class="routes">                        
			<!-- Rotas -->
			<Route path="/home"><Home /></Route>
			<Route path="/"><Home /></Route>		
			<Route path="/go-imovel/:nt/:id/:extra" let:params>
				<Imovel nt="{params.nt}" id="{params.id}" shareCallback={true} />
			</Route>		
			<Route path="/imovel/:nt/:id/:extra" let:params>
				<Imovel nt="{params.nt}" id="{params.id}" />
			</Route>
			<Route path="imoveis/vendas" let:params><Imoveis {...params}/></Route>
			<Route path="imoveis/locacao" let:params><Imoveis {...params}/></Route>
			<Route path="imoveis" let:params><Imoveis {...params}/></Route>

			<Route path="promocoes/vendas" let:params><Promocoes {...params}/></Route>
			<Route path="promocoes/locacao" let:params><Promocoes {...params}/></Route>
			<Route path="promocoes" let:params><Promocoes {...params}/></Route>
			<Route path="anuncie"><Anuncie/></Route>
			<Route path="atualize"><Atualize/></Route>
			<Route path="solicite-imovel"><SoliciteImovel /></Route>
			<Route path="simuladores-financeiros"><Simuladores /></Route>
			<Route path="contato"><Contato /></Route>
			<Route path="documentacao-necessaria"><DocumentacaoNecessaria /></Route>
			<Route path="garantias-locaticias"><GarantiasLocaticias /></Route>
			<Route path="sobre"><Sobre /></Route>
			<Route path="onde-estamos"><OndeEstamos /></Route>
			<Route path="localizacao"><OndeEstamos /></Route>
			<Route path="trabalhe-conosco"><TrabalheConosco /></Route>
			<Route path="favoritos"><Favoritos /></Route>
			<Route path="favoritos-sp"><FavoritosImobiliaria /></Route>
			<Route path="favoritos-amigo"><FavoritosAmigos /></Route>
			<Route path="administracao-condominios"><AdministracaoCondominios /></Route>
			<Route path="solicite-proposta"><SoliciteProposta /></Route>
			<Route path="oops"><Oops /></Route>
			<Route path="obrigado"><Obrigado /></Route>
			<Route path="fichas-cadastrais"><FichasCadastrais /></Route>
			<Route path="seguro-conteudo"><SeguroConteudo /></Route>
		</div>
	</main>
	<Footer/>
	<Aviso />
</Router>